<template>
  <div class="fae-charts">
    <div class="charts-tit">{{ title }}</div>
    <dv-charts :option="option"/>
  </div>
</template>

<script>
export default {
  name: "capsuleChart",
  props: {
    chartData: Object,
    type:String
  },
  data() {
    return {
      title: '',
      option: {}
    }
  },
  mounted() {
    this.title = this.$props.chartData.NAME;
    this.initData()
  },
  methods: {
    initData() {
      let temdata = this.formatData(this.$props.chartData.data,this.$props.type)
      this.option = this.createData(temdata, '{name} {percent}次')
    },
    // 格式化图表数据
    formatData(arr, type) {
      // { name: '收费系统', value: 93 },
      // temObj.name = item.DEPT_NAME + '\n ' + item.APPLY_NAME + ' ' + item.TOP_COUNT + '次';
      let temarr = [];
      arr.map((item, index) => {
        let temObj = {}
        if (type == 'p2p') {
          temObj.name =  item.APPLY_NAME + ' ' + item.TOP_COUNT + '次';
        } else if (type == 'p2d') {
          temObj.name = this.wrappingText(item.APPLY_DEPT_NAME + ' ' + item.TOP_COUNT + '次');
          // temObj.name = item.DEPT_NAME + ' ' + item.TOP_COUNT + '次';
        }else  {
          temObj.name = item.DEPT_NAME  + item.TOP_COUNT + '次';
        }

        temObj.value = item.TOP_COUNT;
        temObj.itemStyle = {normal: {color: '#FE0000'}};
        temarr.push(temObj)
      })
      return temarr
    },
    // 超过4个文字换行
    wrappingText(str) {
      if (str.length > 4) {
        return str.substring(0, 5) + '\n' + str.substring(5)
      } else {
        return str
      }
    },
    // 创建图表
    createData(formatdata, formatter) {
      // console.log(formatdata)
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} KM"
        },
        legend: {
          orient: 'vertical',
          x: 'left',
          top: 40,
          itemWidth: 70,
          itemHeight: 30,
          formatter: '{name}',
          textStyle: {
            color: '#FFFFFF'
          },
          data: []
        },
        calculable: true,
        series: [
          {
            type: 'pie',
            radius: ['40%', '55%'],
            center: ['50%', '50%'],//饼图的位置
            label: {            //饼图图形上的文本标签
              normal: {
                show: true,
                position: 'inner', //标签的位置
                textStyle: {
                  fontWeight: 300,
                  fontSize: 16    //文字的字体大小
                },
                formatter: '{d}%'
              }
            },
            // data:[
            //   {value:50,name:'高速50KM',itemStyle:{normal:{color:'#FE0000'}}}
            // ],
            data: formatdata
          }
        ]
      };
      return option
    },
    /*createData(formatdata, formatter) {
      console.log(formatdata)
      let option = {
        series: [
          {
            type: 'pie',
            data: formatdata,
            radius: ['40%', '45%'],
            insideLabel: {
              show: false
            },
            outsideLabel: {
              labelLineEndLength: 10,
              formatter: formatter,
            }
          }
        ],
        // color: ['#1890ff', '#13c2c2', '#2fc25b', '#facc14', '#f04864', '#8543e0', '#8543e0', '#1890ff', '#13c2c2']
        color: ['#1890ff', '#13c2c2', '#2fc25b', '#f04864', '#8543e0']
      }
      return option
    },*/
  }
}
</script>

<style scoped lang="less">
.fae-charts {
  box-sizing: border-box;
  height: 200px;
  position: relative;

  .charts-tit {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 30px;
    line-height: 30px;
    margin-top: -15px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: .8rem;
  }
}
</style>